import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { DariImage } from 'aurora-components';
import { Alert } from '@material-ui/lab';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import bottomImage from 'aurora-images/authBackground.png';
const useStyles = makeStyles(theme => ({
  frame: {
    minHeight: 'calc(100vh - 0px)',
    background: '#F8F8F8',
    position: 'relative',
    overflowY: 'auto',
    '&:before': {
      content: '""',
      background: `url(${bottomImage}) repeat`,
      width: '100vw',
      height: '300px',
      position: 'absolute',
      bottom: '0px',
      zIndex: 0,
    },
  },
  logoHead: {
    borderBottom: '1px solid #CED1D6',
    width: '100%',
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width: 600px)': {
      border: 'none',
      paddingTop: '50px',
      paddingBottom: '0px',
      '& img': {
        width: '200px',
      },
    },
  },
  aside: {
    textAlign: 'right',
  },
  center: {
    textAlign: 'center',
  },
  paper: {
    maxWidth: '445px',
    position: 'absolute',
    right: '0px',
    left: '0px',
    fontSize: '18px',
    marginLeft: 'auto',
    marginRight: 'auto',
    border: '1px solid #CED1D6',
    padding: '30px',
    borderRadius: '8px',
    '@media (max-width: 600px)': {
      border: 'none',
      padding: '10px',
      paddingTop: '0px',
    },
  },
  bglightgray: {
    background: theme.palette.primary.grey,
  },
  gridTextarea: {
    padding: '27px 0 0',
    marginTop: '50px',
    '& $mainLogoImg': {
      maxWidth: '100%',
    },
    '@media (max-width: 600px)': {
      marginTop: '0px',
    },
  },

  mainLogoImg: {
    background: 'url',
  },
  '@media (min-width: 1200px)': {
    gridTextarea: {
      // padding: '11vh 80px',
    },
  },
  brand: {
    display: 'none',
  },
  // responsiveness
  '@media (max-width: 959.45px)': {
    logoImg: { height: 'auto', maxWidth: '480px', width: '100%' },
    gridTextarea: {
      //  padding: '0 15px',
      flexGrow: '1',
    },
    aside: {
      padding: '24px 32px',
      textAlign: 'center',
    },
    paper: {
      margin: '0 auto',
    },
    // frame: {
    //   height: '100%',
    //   // minHeight: 'calc(80vh - 45px)',
    // },
  },
  '@media (max-width: 600px)': {
    // frame: {
    //   minHeight: 'auto',
    //   paddingBottom: '140px',
    // },
    paper: {
      maxWidth: '100%',
      fontSize: '16px',
    },
  },
  '@media (max-width: 959px)': {
    brand: {
      display: 'flex',
      textAlign: 'center',
      justifyContent: 'center',
      margin: '7vh 0 30px 0',
    },
    bglightgray: {
      background: '#fff',
      marginBottom: '0px',
    },
  },
  width100: {
    width: '100%',
  },
}));

function Template(props) {
  const { children } = props;
  const classes = useStyles();
  document.body.style.overflow = 'hidden';
  return (
    <Fragment>
      <div className={classes.frame}>
        <div className={classes.bottomImage} />
        <Link to='/' className={classes.logoHead}>
          <DariImage name='adrec-logo-header.svg' />
        </Link>

        <div className={classes.gridTextarea}>
          {localStorage.getItem('uae_pass_error') && (
            <Alert severity='error'>
              <FormattedMessage {...messages[localStorage.getItem('uae_pass_error')]} />
            </Alert>
          )}
          <div className={classes.paper}>{children}</div>
        </div>
      </div>
    </Fragment>
  );
}

Template.propTypes = {
  children: PropTypes.node.isRequired,
  image: PropTypes.string,
  page: PropTypes.string.isRequired,
  mainImage: PropTypes.bool.isRequired,
  authType: PropTypes.string,
};

Template.defaultProps = {
  image: null,
  authType: null,
};

export default Template;
